import { memo } from 'react';
import { TextLabel2, TextTitle3 } from '@cbhq/cds-web/typography';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { DisplayType, format } from '@/utils/numberFormatter';
import SummaryCard from './SummaryCard';

type StatsCardProps = {
  tvl: number;
  tvlChange: number;
  volume24h: number;
  volume24hChange: number;
  fees24h: number;
  fees24hChange: number;
};

const StatsCard = memo(function StatsCard({
  tvl,
  tvlChange,
  volume24h,
  volume24hChange,
  fees24h,
  fees24hChange,
}: StatsCardProps) {
  const formatChange = (value: number) => {
    const arrow = value >= 0 ? '\u2197' : '\u2198';
    return `${arrow}${format({ value: Math.abs(value / 100), type: DisplayType.Percentage })}`;
  };

  const header = (
    <TextTitle3 as="h2" testID="stats-card-title">
      Stats
    </TextTitle3>
  );

  return (
    <SummaryCard header={header}>
      <ListCell
        compact
        title="TVL"
        detail={format({ value: tvl, type: DisplayType.FiatShort })}
        subdetail={
          <TextLabel2 as="span" color={tvlChange >= 0 ? 'fgPositive' : 'fgNegative'}>
            {formatChange(tvlChange)}
          </TextLabel2>
        }
      />
      <ListCell
        compact
        title="Volume (24h)"
        detail={format({ value: volume24h, type: DisplayType.FiatShort })}
        subdetail={
          <TextLabel2 as="span" color={volume24hChange >= 0 ? 'fgPositive' : 'fgNegative'}>
            {formatChange(volume24hChange)}
          </TextLabel2>
        }
      />
      <ListCell
        compact
        title="Fees (24h)"
        detail={format({ value: fees24h, type: DisplayType.FiatShort })}
        subdetail={
          <TextLabel2 as="span" color={fees24hChange >= 0 ? 'fgPositive' : 'fgNegative'}>
            {formatChange(fees24hChange)}
          </TextLabel2>
        }
      />
    </SummaryCard>
  );
});

export default StatsCard;
